module.exports = __webpack_public_path__ + "img/KRASNODAR.4489a3fb.png";